
if (!customElements.get('oh-gallery-video')) {
  customElements.define('oh-gallery-video', class extends HTMLElement {
    connectedCallback() {
      if (this.onVideoClick) return;
      this.onVideoClick = () => {
        const gallery = document.getElementById(this.dataset.galleryId);
        const slider = gallery?.querySelector('swiper-product-gallery');
        if (!slider?.instance) return;
        const slides = Array.from(slider.instance.slides);
        const index = slides.findIndex(slide => ['video', 'external_video'].includes(slide.dataset.mediaType) && !slide.classList.contains('hidden'));
        if (index < 0) return;
        slider.enableSwiper?.(true);
        slider.instance.slideTo(index, 300);
        const video = slides[index].querySelector('video');
        if (video) {
          video.muted = true;
          video.playsInline = true;
          video.controls = false;
          video.removeAttribute('controls');
          video.loop = true;
          video.play()?.catch(() => {});
        } else {
          slides[index].querySelector('.product__gallery-toggle')?.click();
        }
      };
      this.querySelector('button')?.addEventListener('click', this.onVideoClick);
    }
    disconnectedCallback() {
      this.querySelector('button')?.removeEventListener('click', this.onVideoClick);
      this.onVideoClick = null;
    }
  });
}
